(function() {
	'use strict';

	angular.module('app.leanProjects')
		.directive('issuesSection', issuesSection);

	issuesSection.$inject = ['$rootScope'];

	function issuesSection($rootScope) {
		return {
			restrict: 'EA',
			templateUrl: '/application/f/lean-projects/projects/issues-section.html',
			scope: {
				projectNdx: '@projectNdx',
				leanDirFactoryNdx: '@leanDirFactoryNdx',
				managerNdx: '@managerNdx',
				projectState: '@projectState',
				authzInfo: '=',
				viewIssueNdx: '=',
				details: '='
			},
			controller: issuesSectionController,
			controllerAs: 'issuesSectionController',
			bindToController: true
		};
	}

	issuesSectionController.$inject = ['$scope', '$rootScope', '$uibModal', '$translate', 'editProjectService', 'leanProjectAuthService', 'issueFormService'];
	function issuesSectionController($scope, $rootScope, $uibModal, $translate, editProjectService, leanProjectAuthService, issueFormService) {
		var vm = this;
		var rootScope = $rootScope;
		var priorityTextToNumMap = {
			'Low': 0,
			'Medium': 1,
			'High': 2,
			'Critical': 3
		};
		vm.issues = [];
		vm.issuesList = [];
		vm.updateIssueGrid = updateIssueGrid;
		vm.actionIsAllowed = actionIsAllowed;
		vm.issueForm = issueForm;
		vm.deleteIssue = deleteIssue;
		vm.lateIssue = lateIssue;

		this.$onInit = function () {
			updateIssueGrid();
		};

		function lateIssue(issueCompletionDate, issueState) {
			var today = new Date().setHours(0,0,0,0);
			issueCompletionDate = new Date(issueCompletionDate);
			if( issueState === 'Pending' || issueState === 'Opened'){
				if( issueCompletionDate < today) {
					return true;
				}
			}
			return false;
		}

		function updateIssueGrid() {
			var viewIssue = null;
			editProjectService.getIssues(vm.projectNdx, vm.leanDirFactoryNdx).then(function(issues) {
				if(issues && issues.length > 0){
					angular.forEach(issues, function(issue) {
						issue.projectedCompleteDate = new Date(issue.projectedCompleteDate);
						var projectedCompleteDateLocal = moment(issue.projectedCompleteDate).add(issue.projectedCompleteDate.getTimezoneOffset(), 'minutes');
						issue.projectedCompleteDate = moment(projectedCompleteDateLocal)._d;
						if (vm.viewIssueNdx != 0 && issue.ndx == vm.viewIssueNdx) {
							viewIssue = issue;
						}
						issue.responsibleDisplay = issue.firstName + ' ' + issue.lastName;
						issue.urgencyType = priorityTextToNumMap[issue.priorityType];
					});
				}
				vm.issuesList = issues;
				vm.issues = [].concat(vm.issuesList);
				if (viewIssue != null) {
					vm.viewIssueNdx = 0;
					issueForm(viewIssue, true);
				}
				$scope.$emit('issuesLoaded');
			});
		}

		function actionIsAllowed(action, responsibleNdx) {
			return leanProjectAuthService.actionIsAllowed(action, vm.details, responsibleNdx);
		}

		function issueForm(issue, viewIssue) {
			var issueFormScope = $scope.$new();
			issueFormScope.issue = jQuery.extend({}, issue);
			issueFormScope.action = typeof issue.ndx === 'undefined' ? 'Add' : 'Edit';
			issueFormScope.viewMode = (viewIssue && viewIssue ? true : false);
			issueFormScope.projectNdx = vm.projectNdx;
			issueFormScope.leanDirFactoryNdx = vm.leanDirFactoryNdx;
			issueFormScope.details = vm.details;
			var opts = {
				scope: issueFormScope,
				templateUrl: '/application/f/lean-projects/projects/issue-form/issue-form.html',
				size: 'lg',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);
			issueFormScope.closeDialog = function() {
				instance.close();
				issueFormScope.$destroy();
			};

			issueFormScope.result = function(message, isSuccessful) {
				$rootScope.$emit('toast', {'message': $translate.instant(message), 'success': isSuccessful});
				if (isSuccessful && message != '') {
					$rootScope.$emit('activityUpdated');
					updateIssueGrid();
				}
				if (isSuccessful || message == '') {
					instance.close();
					issueFormScope.$destroy();
				}
			};
		}

		function deleteIssue(issueNdx) {
			var confirmScope = $scope.$new();
			confirmScope.issueNdx = issueNdx;
			confirmScope.additionalText = 'delete this issue';
			confirmScope.buttonText = 'Delete';
			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function() {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function() {
				var issueNdx = confirmScope.issueNdx;
				instance.close();
				confirmScope.$destroy();
				issueFormService.deleteIssue(issueNdx, vm.projectNdx, vm.leanDirFactoryNdx).then(function(message) {
					var isSuccessful = (message == 'leanProject.toast.deleteIssueSuccess');
					$rootScope.$emit('toast', {'message': $translate.instant(message), 'success': isSuccessful});
					if (isSuccessful) {
						$rootScope.$emit('activityUpdated');
						updateIssueGrid();
					}
				});
			};
		}
	}

})();
